<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">For Nancy Eads,</p>
<p class="ded">who has given so much time,</p>
<p class="ded">effort and enthusiasm to</p>
<p class="ded">being the President of my</p>
<p class="ded">Fan Club</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c9150fc4